import { useTranslation } from "react-i18next";
import {
  BottomTextWrapper,
  ParentBottomTextsWrapper,
  PoweredBy,
} from "../../Sidebar.styled";

export const BottomText = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <ParentBottomTextsWrapper>
      <BottomTextWrapper className="BottomTextWrapper">
        {t("© {{year}} All rights reserved. PZU Kreativa.", {
          year: currentYear,
        })}
      </BottomTextWrapper>
      <PoweredBy>
        <a href="https://vasilht.netlify.app/">
          Designed & Developed by VasilHT.
        </a>
      </PoweredBy>
    </ParentBottomTextsWrapper>
  );
};
